module.exports = __webpack_public_path__ + "static/media/AP Pelvis.551c818c.png";